import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { CoursePaymentWallComponent } from './course-payment-wall.component';

export const ngxCoursePaymentWallModule = angular.module('ngxCoursePaymentWallModule', [])
	.directive('ngxCoursePaymentWall', downgradeComponent({ component: CoursePaymentWallComponent }))
	.name;
